import styled, { css } from 'styled-components';

export const TabContainer = styled.div`
	margin-bottom:50px;
    position:relative;
    &:before{
        content:"";
        width:100%;
        position:absolute;
        height:1px;
        background-color:${(props) => props.theme.colors.dividerColor};
        bottom: -20px;
    }
`;